<template>
    <ContentWrapper class="py-12 text-center">
        <div class="text-3xl font-headings">{{ title }}</div>

        <div class="py-8 max-w-2xl mx-auto">
            {{ copy }}
        </div>

        <div class="w-full aspect-video relative">
            <DeviceWrapper device-type="laptop" :imageSrc="imageSrc" :width="90" />
        </div>

    </ContentWrapper>
</template>
<script setup>
defineProps({
    title: { type: String, required: true },
    copy: { type: String, required: true },
    imageSrc: { type: String, required: true }
})

import ContentWrapper from '@/components/Layouts/ContentWrapper.vue';
import DeviceWrapper from '@/components/DeviceWrapper.vue';
</script>